import axios from 'axios';
import url from './base-url';
const api = axios.create({
    baseURL: url
});
function Headers(auth){
    return {headers:{ 'x-access-token': auth,'Content-Type': 'application/json'}};
}
export const createStore = (payload,auth) => api.post(`/settings/store`, payload);
export const getStores = (userId,auth) => api.get(`/settings/stores/${userId}`,Headers(auth));
export const getStoreByName = (name,auth) => api.get(`/settings/store/${name}`,Headers(auth)); 
export const getOauth = (store,userId,shopName,auth) => api.get(`/settings/${store}/${userId}/${shopName}`,Headers(auth));
export const getAccessToken = (url,auth) => api.get(`/settings/accessToken/${url}`);
export const authorizeAmazonUsers = (userId, payload,auth) => api.post(`/settings/amazon/${userId}`,payload,Headers(auth));
export const syncAllOrdersinStore = (storeId, userId,auth) => api.put(`/settings/${storeId}/${userId}`);

const apis = {
    createStore,
    getStores,
    getStoreByName,
    getAccessToken,
    getOauth,
    authorizeAmazonUsers,
    syncAllOrdersinStore
}

export default apis